import { render, staticRenderFns } from "./aRmsRevenueChannelsTable.vue?vue&type=template&id=48931c92"
import script from "./aRmsRevenueChannelsTable.vue?vue&type=script&lang=js"
export * from "./aRmsRevenueChannelsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAvatar,VDataTable})
